import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/Login'
import Home from '@/view/Home'
import QiDianAdmin from '@/view/QiDian/Admin'
import QiDianAgent from '@/view/QiDian/Agent'
import PhoneBar from '@/view/QiDian/PhoneBar'
import QidianNoPermission from '@/view/QiDian/NoPermission'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    { // 企点签入cc系统-管理端
      path: '/qidian/admin',
      name: 'qidian-admin',
      component: QiDianAdmin
    },
    { // 企点签入cc系统-座席端
      path: '/qidian/agent',
      name: 'qidian-agent',
      component: QiDianAgent
    },
    { // 企点签入cc系统-电话条
      path: '/qidian/phone-bar',
      name: 'qidian-phone-bar',
      component: PhoneBar
    },
    { // 企点无权限页面
      path: '/qidian/error',
      name: 'qidian-error',
      component: QidianNoPermission
    },
    {
      path: '/404',
      name: '404',
      component: Login
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js